const heroTop3 = [
  { rank: 1, title: "收官夜爆灯求婚", heat: 96, up: true },
  { rank: 2, title: "巡演门票四分钟秒空", heat: 91, up: true },
  { rank: 3, title: "全民二创歌曲出圈", heat: 88, up: false },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-[72px]">
      {/* subtle backdrop */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -right-24 -top-24 h-[420px] w-[420px] rounded-full bg-accent-200/50 blur-3xl"></div>
        <div className="absolute -left-24 top-40 h-[360px] w-[360px] rounded-full bg-primary-100/60 blur-3xl"></div>
      </div>

      <div className="mx-auto grid max-w-[1200px] items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14 lg:py-20">
        {/* text first */}
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
            <i className="ri-flashlight-fill text-sm"></i>
            实时热度雷达 · 已连续运转 586 天
          </span>

          <h2 className="mt-6 font-heading text-[2.4rem] font-black leading-[1.12] tracking-tight text-foreground-950 md:text-6xl md:leading-[1.05]">
            今天，谁是真正的
            <br />
            <span className="relative inline-block">
              吃瓜王第一名
              <span className="absolute inset-x-0 bottom-1 -z-10 h-4 rounded-sm bg-accent-300/50 md:h-5"></span>
            </span>
            ？
          </h2>

          <p className="mt-6 max-w-xl text-base leading-7 text-foreground-600 md:text-lg">
            从娱乐到社会热点，我们把全网正在发酵的话题聚合、量化、排进一份公开的吃瓜王排行榜。
            不用蹲热搜，点开就知道今天大家都在吃什么瓜。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#rank"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              立即查看今日瓜榜
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#download"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-foreground-800 whitespace-nowrap transition-colors hover:bg-background-100"
            >
              <i className="ri-download-2-line"></i>
              领取瓜群提醒
            </a>
          </div>

          {/* mini stats */}
          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {[
              { k: "1286", v: "今日收录话题" },
              { k: "3", v: "正在爆榜" },
              { k: "42", v: "待冲榜首" },
            ].map((s) => (
              <div key={s.v}>
                <dt className="font-num text-3xl text-foreground-950">{s.k}</dt>
                <dd className="mt-1 text-xs text-foreground-500">{s.v}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* supporting mini live panel */}
        <div className="relative hidden lg:block">
          <div className="absolute -top-8 right-10 inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 shadow-sm">
            <span className="h-2 w-2 rounded-full bg-primary-500 animate-pulseDot"></span>
            实时热度
          </div>

          <div className="animate-floatY rounded-2xl border border-background-200 bg-background-50/80 p-6 backdrop-blur">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-base font-bold text-foreground-950">此刻最热 · Top 3</h3>
              <span className="rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-900">
                每 30 秒刷新
              </span>
            </div>

            <ul className="mt-5 space-y-4">
              {heroTop3.map((item) => (
                <li key={item.rank} className="flex items-center gap-3">
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-num text-lg ${
                      item.rank === 1
                        ? "bg-accent-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-foreground-800">{item.title}</p>
                    <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-500 animate-riseBar"
                        style={{ width: `${item.heat}%` }}
                      ></div>
                    </div>
                  </div>
                  <span className={`text-sm font-num ${item.up ? "text-primary-600" : "text-foreground-400"}`}>
                    <i className={`ri-arrow-right-up-line mr-0.5 ${item.up ? "" : "rotate-90"}`}></i>
                    {item.heat}
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-5 flex items-center justify-between rounded-xl bg-secondary-100/70 px-4 py-3">
              <span className="text-xs text-foreground-600">今日榜首之争</span>
              <span className="font-num text-xl text-secondary-800">96 <span className="text-xs text-foreground-500">热力值</span></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}